import {useMemo} from 'react';
import {
    useLocation,
    useParams,
} from 'react-router-dom';

export function useSanitisedPathname() {
    const {pathname} = useLocation();
    const params = useParams();

    return useMemo(() => {
        // Get all the parameter keys…
        const keys = Object.keys(params);

        // If we have more than one key, then was can assume that we have some sort or REST style parameter on the end
        // of the URL. We can assume this, as there are no instances where we have parameters embedded in the middle of
        // any routes
        let sanitised = keys.length >= 2
            ? pathname.substring(1, pathname.lastIndexOf('/'))
            : pathname.substring(1);
        sanitised = sanitised.replaceAll('/', '-');

        if (sanitised.endsWith('-')) {
            sanitised = sanitised.slice(0, -1);
        }

        return sanitised;
    }, [pathname]);
}
